import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { openTriggerModal } from '../AutomationTriggerModal';
import useTriggerChange from '../hooks/useTriggerChange';

const PlaceholderNode = ({ id, data }: NodeProps) => {
  const onSelect = useTriggerChange(id);

  return (
    <div
      onClick={() => {
        openTriggerModal({ onSelect });
      }}
      className={'node placeholder'}
      title="click to add a node"
    >
      Select Trigger
      <Handle className={'handle'} type="source" position={Position.Bottom} isConnectable={false} />
    </div>
  );
};

export default memo(PlaceholderNode);
